import React from "react";
import { PaywallTranslations } from "../paywall-comp";
import { Typography } from "../../../../react/components/typography/typography";
import { Button } from "../../../../react/components/button/button";
import { FailureX } from "../../../../react/vectors/failure_x";

export default function FailureView ({
  retryPayment,
  translations,
}: {
  retryPayment: () => void
  translations: PaywallTranslations
}) {
  return (
    <>
      <div
        style={{
          maxWidth: '426px',
          margin: '0 auto',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <FailureX />
        <Typography
          textColor="sys-light-ink-main"
          textSize="sys-display-small"
          element="div"
          style={{textAlign: 'center', marginTop: '16px'}}
        >
          {translations['lokalise.catalog.article_paywall.modal.failure.title']}
        </Typography>

        <Typography
          textColor="sys-light-ink-main"
          textSize="sys-title-medium"
          element="div"
          style={{textAlign: 'center', marginTop: '24px'}}
          dangerouslySetInnerHTML={{__html: translations['lokalise.catalog.article_paywall.modal.failure.body']}}
        />

        <Button
          buttonSize="large"
          buttonStyle="primary"
          element="button"
          theme="light"
          onClick={retryPayment}
          style={{
            width: '100%',
            maxWidth: '326px',
            margin: '32px auto 0 auto'
          }}
          data-testid="paywall-modal-failure-view-retry-button"
        >
          {translations['lokalise.catalog.article_paywall.please_try_again']}
        </Button>
      </div>
    </>
  )
}